import React from 'react'
import cx from 'classnames'
import './style.css'

import { Icon, H1, P, Div } from '@drifthq/tide-core'

export const OnboardingHeader = ({ title, description, className, isPostdated }) => (
  <Div className={cx(className, "onboarding-header")}>
    <H1 className="onboarding-header-section onboarding-header-title">
      {title}
    </H1>
    {description &&
        <P className="onboarding-header-section onboarding-header-description">
          {description}
        </P>
    }
    { isPostdated &&
      <Div className="onboarding-header-section onboarding-header-postdating-warning">
        <Icon
          height={13}
          width={12}
          name="warning-triangle"
        />
        <Div>
        Your account will have limited functionality until your subscription activation date
        </Div>
      </Div>
    }
  </Div>
)



// WEBPACK FOOTER //
// ./src/components/OnboardingHeader/index.js